import React from 'react'
import { Link } from 'react-router-dom'

function PreOrderMeals() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>

        <div className="auto-container">
          <div className="inner">
            <h1>Pre-order Meals</h1>
            <div className="sub_text">
              <p>
                Home -{" "}
                <a href="" className="primary-color">
                  Pre-order Meals
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle">
              <span>Tickling Tummy</span>
            </div>

            <h2>
              <span className="theme_color">Pre-order Meals </span> — Savor What
              You Crave in Coimbatore
            </h2>
          </div>

          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Don’t settle for “whatever’s available.” At Tickling Tummy, we
                believe food should comfort your soul and care for your health.
                That’s why our pre-order meals are designed not just to satisfy
                cravings, but to suit your exact preferences — just like Amma
                made at home.
                <br />
                <br />
                From the moment you place an order, we make sure it’s
                personalized. Craving spicy kadai paneer with a side of jeera
                rice? Or maybe you’d prefer the same dish with less oil, no
                ghee, and low salt for a healthier meal? We’ve got you. Want
                your snacks air-fried instead of deep-fried, or your vada
                crispy? Just mention it — we’ll prepare your meal the way you’d
                make it for yourself or a loved one.
                <br />
                <br />
                From our cozy kitchen in R.S. Puram, we serve working
                professionals, seniors, families, and students across Coimbatore
                — including Avinashi Road, Ganpathy, Gandhi Park, Gandhipuram,
                Koundampalayam, Ponyarajpuram, Race Course, Ram Nagar, Saibaba
                Colony, Saravanampatti. Sulur. Thudiyalur, Trichy Road,
                Vadavalli and more.
              </p>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />

      {/* Why Choose Us Section */}
      <section className="why-choose-us style-two">
        <div className="auto-container">
          {/* FIRST BLOCK */}
          <div className="row">
            <div className="col-lg-6 col-md-12 image-column">
              <div className="image-box">
                <figure className="image">
                  <img src="assets/images/pre-order-custom-meals-coimbatore.jpg" alt="preorder meals" />
                </figure>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 content-column">
              <div className="inner-box">
                <div className="sec-title">
                  <h2>What Makes Our Pre-order Meals Stand Out?</h2>
                </div>

                <ul className="list-style-two">
                  <li>
                    ◆ Custom-cooked-home-style: From cherished idlis, biryani to
                    special moms, we serve dishes you love
                  </li>
                  <li>
                    ◆ Pure veg & homemade: No preservatives, no shortcuts—just
                    authentic flavor
                  </li>
                  <li>
                    ◆ Extensive menu variety: North & South Indian, global
                    comfort meals, rotating specials
                  </li>
                  <li>
                    ◆ Hygienic & fresh: Prepared daily in R.S. Puram kitchen
                    using quality ingredients
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* SECOND BLOCK */}
          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-lg-6 col-md-12 content-column order-lg-1 order-2">
              <div className="inner-box">
                <div className="sec-title">
                  <h2>How It Works</h2>
                </div>

                <ul className="list-style-two">
                  <li>
                    ◆ Check our Pre-order Menu (<a href="#"></a>)
                  </li>
                  <li>
                    ◆ Place your order via WhatsApp (
                    <a
                      href="https://wa.me/919385000111?text=Hello%2C%20I%20would%20like%20to%20know%20more."
                      target="_blank"
                      rel="noreferrer"
                    >
                      +91-9385000111
                    </a>
                    )
                  </li>
                  <li>◆ We cook it fresh, just the way Amma made it</li>
                  <li>◆ Pick up your order from R.S. Puram</li>
                  <li>◆ Relish your customized, home-style veg feast!</li>
                </ul>

                <p style={{ marginTop: "15px" }}>
                  ◆ Follow us on Instagram (
                  <a
                    href="https://www.instagram.com/tickling.tummy/?igsh=dmlwM29pNjc4a3Fw#"
                    target="_blank"
                    rel="noreferrer"
                  >
                    @tickling.tummy
                  </a>
                  ) to see Surprise Specials!
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 image-column order-lg-2 order-1">
              <div className="image-box">
                <figure className="image">
                  <img src="assets/images/authentic-south-indian-thali-coimbatore.jpg" alt="custom veg meals" />
                </figure>
              </div>
            </div>
          </div>

          {/* THIRD BLOCK */}
          <div className="row" style={{ marginTop: "50px" }}>
            <div className="col-lg-12">
              <div className="inner-box centered">
                <div className="sec-title">
                  <h2>Perfect For...</h2>
                </div>

                <ul
                  className="list-style-two"
                  style={{ maxWidth: "700px", margin: "0 auto" }}
                >
                  <li>◆ Busy professionals who miss home-cooked meals</li>
                  <li>◆ Seniors who want customized food as per their taste</li>
                  <li>◆ Vegetarians craving custom-prepared dishes</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <br />
      <br />
      <br />

      {/* FAQ Schema for Pre-order Meals */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How far in advance should I place a pre-order?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "For small customized orders, we recommend at least 3-4 hours notice. For larger party orders, 24-48 hours notice is ideal to ensure the freshest ingredients."
              }
            },
            {
              "@type": "Question",
              "name": "Can you cook food with specific health requirements?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! Our pre-order service is perfect for those needing low-salt, low-oil, or specific vegetable-based diets. Just let us know while ordering."
              }
            },
            {
              "@type": "Question",
              "name": "What is the most popular pre-order item?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our North Indian combos and authentic South Indian thalis are highly popular for weekend family lunches and small gatherings."
              }
            }
          ]
        })}
      </script>
    </>

  );
}

export default PreOrderMeals
